export default {
    messageManagement: 'Message Management'
}
